module.exports = __webpack_public_path__ + "static/media/brad-logo.e6f83cc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brad-logo.png
// module id = 25
// module chunks = 0